import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import config from '../config';
import PlanDetails from './PlanDetails';
import axios from 'axios';


function CobraPlans({ caseId, planType, coverageType, title, onError = () => { } }) {

    const [plans, setPlans] = useState({
        cobraMedicalPlans: [],
        cobraDentalPlans: [],
        cobraVisionPlans: [],
        cobraEAPPlans: [],
        cobraHRAPlans: [],
        cobraFSAPlans: [],
        cobraInsurancePlans: []
      });

      const [oldPlans, setOldPlans] = useState({
        cobraMedicalPlans: [],
        cobraDentalPlans: [],
        cobraVisionPlans: [],
        cobraEAPPlans: [],
        cobraHRAPlans: [],
        cobraFSAPlans: [],
        cobraInsurancePlans: []
      });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const medicalFetchUrl = `${config.API_URL}/cobraMedicalPlans/ByCaseId/${caseId}`;
  const dentalFetchUrl = `${config.API_URL}/cobraDentalPlans/ByCaseId/${caseId}`;
  const visionFetchUrl = `${config.API_URL}/cobraVisionPlans/ByCaseId/${caseId}`;
  const EAPFetchUrl = `${config.API_URL}/cobraEAPPlans/ByCaseId/${caseId}`;
  const HRAFetchUrl = `${config.API_URL}/cobraHRAPlans/ByCaseId/${caseId}`;
  const FSAFetchUrl = `${config.API_URL}/cobraFSAPlans/ByCaseId/${caseId}`;
  const insuranceFetchUrl = `${config.API_URL}/cobraInsurancePlans/ByCaseId/${caseId}`;

  const medicalOldFetchUrl = `${config.API_URL}/cobraMedicalPlans/OriginalData/ByCaseId/${caseId}`;
  const dentalOldFetchUrl = `${config.API_URL}/cobraDentalPlans/OriginalData/ByCaseId/${caseId}`;
  const visionOldFetchUrl = `${config.API_URL}/cobraVisionPlans/OriginalData/ByCaseId/${caseId}`;
  const EAPOldFetchUrl = `${config.API_URL}/cobraEAPPlans/OriginalData/ByCaseId/${caseId}`;
  const HRAOldFetchUrl = `${config.API_URL}/cobraHRAPlans/OriginalData/ByCaseId/${caseId}`;
  const FSAOldFetchUrl = `${config.API_URL}/cobraFSAPlans/OriginalData/ByCaseId/${caseId}`;
  const insuranceOldFetchUrl = `${config.API_URL}/cobraInsurancePlans/OriginalData/ByCaseId/${caseId}`;
    
    useEffect(() => {
        const fetchPlans = async () => {
            try {
              
              const responses = await Promise.allSettled([
                axios.get(medicalFetchUrl),
                axios.get(dentalFetchUrl),
                axios.get(visionFetchUrl),
                axios.get(EAPFetchUrl),
                axios.get(HRAFetchUrl),
                axios.get(FSAFetchUrl),
                axios.get(insuranceFetchUrl),
              ]);
          
              
              const plansData = {
                cobraMedicalPlans: [],
                cobraDentalPlans: [],
                cobraVisionPlans: [],
                cobraEAPPlans: [],
                cobraHRAPlans: [],
                cobraFSAPlans: [],
                cobraInsurancePlans: []
              };
          
              
              responses.forEach((result, index) => {
                if (result.status === 'fulfilled') {
                  switch (index) {
                    case 0:
                      plansData.cobraMedicalPlans = result.value.data || [];
                      break;
                    case 1:
                      plansData.cobraDentalPlans = result.value.data || [];
                      break;
                    case 2:
                      plansData.cobraVisionPlans = result.value.data || [];
                      break;
                    case 3:
                      plansData.cobraEAPPlans = result.value.data || [];
                      break;
                    case 4:
                      plansData.cobraHRAPlans = result.value.data || [];
                      break;
                    case 5:
                      plansData.cobraFSAPlans = result.value.data || [];
                      break;
                    case 6:
                      plansData.cobraInsurancePlans = result.value.data || [];
                      break;
                    default:
                      break;
                  }
                }
              });
          
              
              setPlans(plansData);
              
            } catch (err) {
              setError('Error fetching plans.');
              console.error('Error fetching plans:', err);
            } finally {
              setLoading(false);
            }
          };

          const fetchOldPlans = async () => {
            try {
              
              const responses = await Promise.allSettled([
                axios.get(medicalOldFetchUrl),
                axios.get(dentalOldFetchUrl),
                axios.get(visionOldFetchUrl),
                axios.get(EAPOldFetchUrl),
                axios.get(HRAOldFetchUrl),
                axios.get(FSAOldFetchUrl),
                axios.get(insuranceOldFetchUrl),
              ]);
          
              
              const oldPlansData = {
                cobraMedicalPlans: [],
                cobraDentalPlans: [],
                cobraVisionPlans: [],
                cobraEAPPlans: [],
                cobraHRAPlans: [],
                cobraFSAPlans: [],
                cobraInsurancePlans: []
              };
          
              
              responses.forEach((result, index) => {
                if (result.status === 'fulfilled') {
                  switch (index) {
                    case 0:
                      oldPlansData.cobraMedicalPlans = result.value.data || [];
                      break;
                    case 1:
                      oldPlansData.cobraDentalPlans = result.value.data || [];
                      break;
                    case 2:
                      oldPlansData.cobraVisionPlans = result.value.data || [];
                      break;
                    case 3:
                      oldPlansData.cobraEAPPlans = result.value.data || [];
                      break;
                    case 4:
                      oldPlansData.cobraHRAPlans = result.value.data || [];
                      break;
                    case 5:
                      oldPlansData.cobraFSAPlans = result.value.data || [];
                      break;
                    case 6:
                      oldPlansData.cobraInsurancePlans = result.value.data || [];
                      break;
                    default:
                      break;
                  }
                }
              });
          
              
              setOldPlans(oldPlansData);
              
            } catch (err) {
              setError('Error fetching plans.');
              console.error('Error fetching plans:', err);
            } finally {
              setLoading(false);
            }
          };

          
          fetchPlans();
          fetchOldPlans();
      }, []);

    
    if (loading) return <Skeleton count={10} />;
    if (error) return <div>{error}</div>;

    const cobraPlans = plans?.[planType] || [];
    const cobraOldPlans = oldPlans?.[planType]

    const planLabels = {
        title: title,
        fields: [
            { label: 'Carrier Name', key: 'carrierName', id: 'carrierName' },
            { label: 'Plan Name', key: 'planName', id: 'planName' },
            { label: 'State of Plan Issuance', key: 'incorporationState', id: 'incorporationState' },
            { label: 'Group Number', key: 'groupNumber', id: 'groupNumber' },
            { label: 'Sub Group Number', key: 'subGroupNumber', id: 'subGroupNumber' },
            { label: 'Plan Renewal Date', key: 'planRenewalDate', id: 'planRenewalDate' },
            { label: 'Insurance Type', key: 'insuranceType', id: 'insuranceType' },
            { label: 'This plan is available only to a specific division', key: 'isDivisionSpecific', id: 'isDivisionSpecific' },
            { label: 'Selected Divisions', key: 'SelectedDivisions', id: 'SelectedDivisions' },
            { label: 'Currently charging additional 50% of the premium for disability extension?', key: 'isDisabilityExtension', id: 'isDisabilityExtension' },
            { label: 'Coverage Termination Rule', key: 'planRule', id: 'planRule' },
            { label: 'Plan Rate Type', key: 'planRateType', id: 'planRateType' },
        ],
    };

    return (
        <PlanDetails
        oldPlanData ={cobraOldPlans}
            planData={cobraPlans}
            planLabels={planLabels}
            coverageType= {coverageType}
            caseId={caseId}
            
        />
    );
}

export default CobraPlans;
